import { Box, Button, Flexbox, Heading, Modal, ModalBody, ModalFooter, ModalHeader, Select, Stack, StackRow } from "codekit";
import React, { useState } from "react";
import { useUserAbsentMutation } from "../../libs/redux/slices/authSlice/authApiSlice";

const Userause = ({ infoUser, setOpenModalAusent }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [justification, setJustification] = useState('');
  const [userAbsent, { isLoading }] = useUserAbsentMutation();
  const { USRIDXXX, USREMAXX } = infoUser;


  const handleSubmit = async () => {
    await userAbsent({ "USRIDXXX": USRIDXXX, "USREMAXX": USREMAXX, "JUSTIFIC": justification }).unwrap();
    setOpenModalAusent(false);
  }

  return (
    <>
      <Modal isOpen={!isOpen}>
        <ModalHeader>
          <Flexbox justifyContent="between" alignItems="center">
            <Heading variant="heading-5">Justificacion Ausentismo</Heading>
            <Button variant="secondary" onlyIcon icon='close' size="m" onClick={() => setOpenModalAusent(false)}>
            </Button>
          </Flexbox>
        </ModalHeader>
        <ModalBody size="sm">
          <Box mb={8} bg="neutral-200" border={1} borderColor="neutral-300" spacing={3} rounded="md">
            <Box spacing={5} border={1} rounded='md' borderColor='neutral-300' bg='white'>
            <Stack gap={4}>
              <StackRow>
                <Select options={[{
                value: '1',
                text: 'Reunion 2 horas'
              }, {
                value: '2',
                text: 'Reunion 3 horas'
              }, {
                value: '3',
                text: 'Reunion 4 horas'
              }]}
              value={justification}
              onChangeValue={context => {
                setJustification(context.option.value);
              }} />
              </StackRow>
            </Stack>
          </Box>
          </Box>

        </ModalBody>
        <ModalFooter>
          <Flexbox justifyContent="between" alignItems="center" gap={4}>
            <Button type="button" variant="secondary" size="2l" minWidth={200} onClick={() => setOpenModalAusent(false)}>
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="primary-bold"
              size="2l"
              minWidth={200}
              onClick={handleSubmit}
              disabled={justification === ''}
              isLoading={isLoading}
            >
              Guardar
            </Button>
          </Flexbox>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Userause;
